module.exports = __webpack_public_path__ + "static/img/successful_icon.11b6fb78.png";